import VueI18n from 'vue-i18n'
import deepmerge from 'deepmerge'

import elZhCNLocale from 'element-ui/src/locale/lang/zh-CN';
import elEnLocale from 'element-ui/src/locale/lang/en';

import linkZhCNLocale from './lang/link-ui/zh-CN';
import linkEnLocale from './lang/link-ui/en';

const DEFAULT_LANG = 'zh-CN'; //默认语言

const DEFAULT_LANGS = {
    'zh-CN': deepmerge(elZhCNLocale,linkZhCNLocale),
    'en-US': deepmerge(elEnLocale,linkEnLocale)
};

const cacheMap = {}; //语言缓存

/**
 * @method：use
 * @createdBy:HuangJian
 * @date:2019/10/16
 * @params：
 * @description：添加并使用语言库
 */
export function use(lang,locale) {
    lang = lang || DEFAULT_LANG;
    const defaultLang =DEFAULT_LANGS[lang] || {};
    locale = deepmerge(defaultLang, locale || {}, {clone:true});
    cacheMap[lang]=locale;
    Vue.locale(lang,locale);
    Vue.config.lang = lang;
}
/**
 * @method：switchTo
 * @createdBy:HuangJian
 * @date:2019/10/17
 * @params lang：语言
 * @params loadMethod：加载语言包的方法
 * @description：切换语言库
 */
export async function switchTo(lang, loadMethod) {
    let locale = cacheMap[lang];
    if(!locale){
        if(typeof loadMethod === 'function'){
            locale = await loadMethod(lang);
        }
        use(lang,locale);
    }else {
        Vue.config.lang = lang;
    }
}

/**
 * @method：getCurrentLanguage
 * @createdBy:HuangJian
 * @date:2019/10/17
 * @params：
 * @description：获取当前语言
 */
export function getCurrentLanguage() {
    return Vue.config.lang;
}

/**
 * @method：install
 * @createdBy:HuangJian
 * @date:2019/10/16
 * @params Vue：Vue原型
 * @params opts：配置
 * @description：Vue安装函数
 */
const install = (Vue,opts)=>{
    Vue.use(VueI18n);
    opts = opts || {};
    use(opts.lang,opts.locale);
}
export default {install,use,switchTo,DEFAULT_LANG,getCurrentLanguage}
